import React, { useState } from "react";
import { connect } from "react-redux";
import Dashboard from "./Dashboard";
import Sidebar from "../components/Sidebar";
import { useLocation } from "react-router-dom";
import Storefront from "./Storefront";
import NotFound from "./NotFound";
import Settings from "./Settings";
import ProductDetail from "./ProductDetail";
import WalmartProductDetail from "./WalmartProductDetail";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import Favorites from "./Favorites";
import History from "./History";

export const Index = (props) => {
  const [sidebarClosingStatus, setSidebarClosingStatus] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="flex">
      {/* Mobile Sidebar */}
      <div
        className={`fixed inset-0 z-40 transition-transform duration-300 ease-in-out lg:hidden ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-40"
          onClick={closeSidebar}
        ></div>
        <div className="relative h-full w-fit max-w-full bg-primary-bg">
          <Sidebar
            setSidebarClosingStatus={setSidebarClosingStatus}
            sidebarClosingStatus={sidebarClosingStatus}
          />
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div
        id="sidebar"
        className="hidden lg:block transition-all duration-150 ease-in-out"
      >
        <Sidebar
          setSidebarClosingStatus={setSidebarClosingStatus}
          sidebarClosingStatus={sidebarClosingStatus}
        />
      </div>

      <div
        className={`flex-1 min-h-screen bg-primary-bg ${
          sidebarClosingStatus ? `lg:ml-[240px]` : `lg:ml-[80px]`
        }`}
      >
        <div className="flex items-center justify-between px-4 py-3 lg:hidden">
          <button
            className="text-white text-2xl"
            onClick={handleToggleSidebar}
            aria-label="Toggle Sidebar"
          >
            <HiOutlineMenuAlt2 />
          </button>
        </div>

        <div className="px-2 lg:px-0">
          {location.pathname === "/dashboard" ? (
            <Dashboard setSidebarClosingStatus={setSidebarClosingStatus} />
          ) : location.pathname === "/storefront-stalking" ? (
            <Storefront />
          ) : location.pathname === "/settings" ? (
            <Settings />
          ) : location.pathname === "/product" ? (
            <ProductDetail />
          ) : location.pathname === "/walmart-product" ? (
            <WalmartProductDetail />
          ) : location.pathname === "/favorites" ? (
            <Favorites />
          ) : location.pathname === "/history" ? (
            <History />
          ) : (
            <NotFound />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
